// extracted by mini-css-extract-plugin
module.exports = {"selector":"ThemeSelector_selector__3ar3h","dark":"ThemeSelector_dark__2T8AS","icon":"ThemeSelector_icon__19mQa"};